module.exports = __webpack_public_path__ + "static/media/galerija_2016 (2).e66d2dff.jpg";